import React, { useState } from 'react';
import { LayoutDashboard, UsersRound, Calculator, ClipboardCheck, ListChecks } from 'lucide-react';
import { CrmDashboard } from './CrmDashboard';
import { CrmClients } from './CrmClients';
import { CrmSuivi } from './CrmSuivi';
import { ClientFileDialog } from './ClientFileDialog';
import { EaserDevisGreen } from '../EaserDevisGreen';
import { EaserQualite } from '../EaserQualite';

export const CRM_SUBTABS = [
  { id: 'dashboard', label: 'Tableau de bord', icon: LayoutDashboard },
  { id: 'clients', label: 'Clients', icon: UsersRound },
  { id: 'devis', label: 'Devis', icon: Calculator },
  { id: 'controles', label: 'Contrôles', icon: ClipboardCheck },
  { id: 'suivi', label: 'Suivi', icon: ListChecks },
];

/** Onglet CRM des managers : sous-navigation mobile + fiche client ouvrable depuis n'importe quelle rubrique. */
export function EaserCrm({ user, sub, view, onNavigate, onUnauthorized }) {
  const [client, setClient] = useState(null); // {socid, name}
  const current = CRM_SUBTABS.some((t) => t.id === sub) ? sub : 'dashboard';
  const openClient = (socid, name) => { if (socid) setClient({ socid: Number(socid), name }); };

  return (
    <div className="space-y-4" data-testid="easer-crm">
      <div className="flex gap-1 overflow-x-auto pb-1 -mx-1 px-1 rounded-xl" role="tablist" aria-label="Rubriques CRM">
        {CRM_SUBTABS.map((t) => {
          const active = current === t.id;
          return (
            <button key={t.id} type="button" role="tab" aria-selected={active} onClick={() => onNavigate(t.id)} data-testid={`crm-sub-${t.id}`}
              className={`flex items-center gap-1.5 min-h-[44px] px-3 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${active ? 'bg-[hsl(var(--primary))] text-white' : 'bg-card border border-border text-muted-foreground hover:text-foreground hover:bg-secondary'}`}>
              <t.icon className="h-4 w-4" /> {t.label}
            </button>
          );
        })}
      </div>

      {current === 'dashboard' && <CrmDashboard onNavigate={onNavigate} onOpenClient={openClient} onUnauthorized={onUnauthorized} />}
      {current === 'clients' && <CrmClients onOpenClient={openClient} onUnauthorized={onUnauthorized} />}
      {current === 'devis' && <EaserDevisGreen user={user} onUnauthorized={onUnauthorized} />}
      {current === 'controles' && <EaserQualite user={user} onUnauthorized={onUnauthorized} />}
      {current === 'suivi' && <CrmSuivi view={view} onChangeView={(v) => onNavigate('suivi', v)} onOpenClient={openClient} onUnauthorized={onUnauthorized} />}

      <ClientFileDialog open={!!client} socid={client?.socid} clientName={client?.name} userId={user?.id} onClose={() => setClient(null)} onUnauthorized={onUnauthorized} />
    </div>
  );
}
